// directives/vCdnSimple.ts
import type { Directive } from 'vue';

type DomainMap = Record<string, string>;

const DOMAIN_MAP: DomainMap = {
  // 'localhost': 'cdn.example.com',
  // '127.0.0.1': 'cdn.example.com',
  // '8.152.163.74:7001':'www.baidu.com',

  //旧域名对应图片或链接地址
  'academy-outbound-ads.tiktok.com':'lf16-tt4b-academy.fcdnoverseasc.com',

  //新域名对应图片或链接地址
  'www.tiktokforbusiness-learning-center.com':'sf-obj.tiktokforbusiness-learning-center.com',
  'tiktokforbusiness-learning-center.com':'sf-obj.tiktokforbusiness-learning-center.com'

};

export const vCdnSimple: Directive<HTMLImageElement|HTMLAnchorElement | HTMLElement, DomainMap> = {
  mounted(el, { value = {} }) {
    updateDomain(el, value);
  },
  updated(el, { value = {} }) {
    updateDomain(el, value);
  }
};

function updateDomain(el: HTMLImageElement | HTMLAnchorElement | HTMLElement, customMap: DomainMap): void {
  // if (!el.src && !el.href) return;
  
  try {


    if (el instanceof HTMLImageElement) { 

        const url = new URL(el.src);
        const map = { ...DOMAIN_MAP, ...customMap };
        
        if (map[location.hostname] !== undefined) { 

          //处理 src 属性，替换域名
          //根据域名替换URL
          el.src !== undefined &&  
          (el.src = el.src.replace(url.host, map[location.hostname]));

        }
    } 
 

    if (el instanceof HTMLAnchorElement) {
        const url = new URL(el.href);
        const map = { ...DOMAIN_MAP, ...customMap };  
        if (map[location.hostname] !== undefined) {
          //处理 href 属性，替换域名
          el.href !== undefined &&  
          (el.href = el.href.replace(url.host, map[location.hostname]));
  
        } 
    }

    //处理el-image组件内的img
    if (el instanceof HTMLElement) {
      const imgEl = el.querySelector('img');  
      if (imgEl) {
        const url = new URL(imgEl.src);
        const map = { ...DOMAIN_MAP, ...customMap };    
        if (map[location.hostname] !== undefined) {
          //处理 img 的 src 属性，替换域名
          imgEl.src !== undefined &&  
          (imgEl.src = imgEl.src.replace(url.host, map[location.hostname]));
        } 
      }
    }

   
  } catch {
    // 无效URL，忽略
  }
}